import { useFormikContext } from 'formik'
import CalendarField from '../../components/CalendarField'
import AutoCompleteField, { VField } from '../../components/Fields'
import { Bilancia, BilanciaDeadSimple, Intervento } from '../../types'
import { getLabelTipoBilancia } from '../../utils/utils'
import { API_URL } from '../../constants'

export default function FormProgrammaIntervento({
  bilancia,
}: {
  bilancia: BilanciaDeadSimple | Bilancia | undefined
}) {
  const { values, setFieldValue } = useFormikContext<Intervento>()

  return (
    <div className="row">
      <div className="col-6">
        <div className="heading-h3">
          {bilancia?.matricola} {bilancia?.sigla ? `(${bilancia.sigla})` : ''} -{' '}
          {getLabelTipoBilancia(bilancia?.tipo_bilancia)}
        </div>
        <div className="p-md text-body-secondary">
          {bilancia?.cliente_ragione_sociale} -{' '}
          {bilancia?.sede_data?.numero_rea} {bilancia?.reparto}
        </div>
        <div className="mt-3">
          <VField name="note" label="Note" as="textarea" />
        </div>
        <div className="mt-3">
          <AutoCompleteField
            name="utente"
            label="Operatore"
            value={values.utente}
            url={`${API_URL}/utenti/users/options-operatori/`}
          />
        </div>
        <div className="mt-3">
          <VField
            name="durata_stimata"
            label="Durata stimata"
            type="time"
          />
        </div>
      </div>
      <div className="col-md-6">
        <CalendarField
          setDataIntervento={(data) => {
            setFieldValue('data_intervento', data)
          }}
          type={values.tipo_intervento}
          dataIntervento={values.data_intervento}
        />
      </div>
    </div>
  )
}
